export interface PersonalizedText {
  header: string
  description: string
}

export const personalizedPricingContent: {
  problems: Record<string, PersonalizedText>
  roles: Record<string, PersonalizedText>
  organizations: Record<string, PersonalizedText>
  default: PersonalizedText
} = {
  problems: {
    onbp_sxN86RR6Ernu: {
      // Finding High-Quality Link Prospects
      header: 'Stop Wasting Time Finding Link Prospects',
      description:
        'Our plans are designed to help you discover and qualify top-tier backlink opportunities efficiently.',
    },
    onbp_OeTIcPqd4w7C: {
      // Drafting Personalized Outreach Messages
      header: 'Craft Outreach That Converts',
      description:
        'Streamline your communication with tools that help you craft and send effective outreach at scale.',
    },
    onbp_jpFRn8TtCUP5: {
      // Efficient Contact Discovery
      header: 'Discover the Right Contacts, Faster',
      description: 'Find verified contact information for your link prospects in seconds.',
    },
    onbp_yiOG3BaQ5vK5: {
      // Maintaining Organized Campaign Management
      header: 'Organize Your Link Building Like a Pro',
      description: 'Keep your campaigns on track with our intuitive management tools.',
    },
    onbp_kMpW1iuvsMAo: {
      // Automating Routine Tasks
      header: 'Automate the Tedious, Focus on Strategy',
      description:
        'Let our platform handle repetitive tasks so you can focus on high-impact activities.',
    },
    onbp_Q8CflPKb1cMC: {
      // Performing In-depth Backlink Analysis
      header: 'Deep Dive Into Backlink Profiles',
      description:
        "Gain comprehensive insights into any website's backlink profile with our analysis tools.",
    },
  },
  roles: {
    onbr_mzeIRfSHOW1M: {
      // SEO Specialist
      header: 'Pricing Tailored for SEO Specialists',
      description: 'Unlock the tools you need to dominate the SERPs and drive organic growth.',
    },
    onbr_s7zsmShCySfR: {
      // Link Building Specialist
      header: 'Link Building, Supercharged.',
      description:
        'For Link Building Specialists: Find the tools you need to scale your outreach and secure high-quality backlinks.',
    },
    onbr_VVaQxAziztq0: {
      // Content Marketer
      header: 'Amplify Your Content Reach',
      description:
        'Content Marketers, build authoritative links that drive traffic to your best work.',
    },
    onbr_28ZR7MPnTwqi: {
      // Small Business Owner
      header: 'Grow Your Business with Powerful Links',
      description: 'Small Business Owners, get the SEO firepower you need to compete and win.',
    },
    onbr_oAQ4nkUH2qhX: {
      // Digital Marketing Manager
      header: "Manage Your Team's Link Building Efforts",
      description:
        "Digital Marketing Managers, streamline your team's workflow and achieve your SEO goals.",
    },
  },
  organizations: {
    onbo_YcYLG9XOm3yb: {
      // Startup
      header: 'Link Building Solutions for Startups',
      description: 'Grow your Startup with our powerful and affordable link-building plans.',
    },
    onbo_hrEZ7bBb1RYq: {
      // Marketing Agency
      header: "Empower Your Agency's Link Building",
      description:
        'Equip your Marketing Agency with the tools to manage client campaigns and deliver outstanding link-building results.',
    },
    onbo_0BBUAPbztMD2: {
      // E-commerce Business
      header: 'Boost Your E-commerce SEO',
      description:
        'Drive more organic traffic and sales to your e-commerce store with strategic link building.',
    },
    onbo_f4nLhnvc05Gr: {
      // Small Business
      header: 'Affordable SEO for Small Businesses',
      description:
        'Get the link building tools you need without breaking the bank. Perfect for small businesses.',
    },
  },
  default: {
    header: 'Pricing for Everyone',
    description: 'Choose the perfect plan powering your link-building campaigns.',
  },
}

export function getPersonalizedPricingText(
  onboardingProblemId?: string | null,
  onboardingRoleId?: string | null,
  onboardingOrganizationId?: string | null,
): PersonalizedText {
  if (onboardingProblemId && personalizedPricingContent.problems[onboardingProblemId]) {
    return personalizedPricingContent.problems[onboardingProblemId]
  }

  if (onboardingRoleId && personalizedPricingContent.roles[onboardingRoleId]) {
    return personalizedPricingContent.roles[onboardingRoleId]
  }

  if (
    onboardingOrganizationId &&
    personalizedPricingContent.organizations[onboardingOrganizationId]
  ) {
    return personalizedPricingContent.organizations[onboardingOrganizationId]
  }

  return personalizedPricingContent.default
}
